import { array, lazy, object, optional, Schema } from '../schema';
import { Card, cardSchema } from './card';
import { Error, errorSchema } from './error';

/**
 * Defines the fields that are included in the response body of
 * a request to the CreateCustomerCard endpoint.
 * One of `errors` or `card` is present in a given response (never both).
 */
export interface CreateCustomerCardResponse {
  /** Any errors that occurred during the request. */
  errors?: Error[];
  /**
   * Represents the payment details of a card to be used for payments. These
   * details are determined by the `card_nonce` generated by `SqPaymentForm`.
   */
  card?: Card;
}

export const createCustomerCardResponseSchema: Schema<CreateCustomerCardResponse> = object(
  {
    errors: ['errors', optional(array(lazy(() => errorSchema)))],
    card: ['card', optional(lazy(() => cardSchema))],
  }
);
